var _circle, _path, _ellipse, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 470.5,
    cy: 153.5,
    r: 62.5,
    fill: "#17C7E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.692 299.429C247.501 338.619 324.094 325.409 363.765 269.927C403.436 214.445 391.165 137.696 336.356 98.5066C281.547 59.3171 204.954 72.5262 165.283 128.009C125.612 183.491 137.883 260.24 192.692 299.429Z",
    fill: "url(#loaderGradient6)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.922,
    cy: 591.848,
    rx: 165,
    ry: 164.5,
    transform: "rotate(-7.70863 306.922 591.848)",
    fill: "#ED801B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loaderGradient6",
    x1: 223.386,
    y1: 199.202,
    x2: 388.041,
    y2: 200.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DB8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009458"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.c528c3627d3ca8da4e475eb313f361d212495c55a53b8d3c12e43c624ba87f7e.svg";
export { ForwardRef as ReactComponent };